'use client';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { promotionClicked } from '@repo/ui/src/services/analytics';
import { LinkProps } from '@repo/ui/src/types';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';
import CountDownClock, { CountdownClockProps } from '../SiteWideBanner/_CountdownClock';
import React from 'react';

export interface SitewidePromotionProps {
  link: LinkProps;
  text: string;
  countdownClock?: CountdownClockProps;
  promotionId: string;
  isDefault: boolean | null;
  rotationTime: 'long' | 'standard';
  index?: number;
}

const SitewidePromotion = ({
  link,
  text,
  promotionId,
  countdownClock,
  index,
}: SitewidePromotionProps) => {
  return (
    <li
      className={`slider-${index} inline-flex items-center flex-row flex-wrap absolute opacity-0 first:relative first:opacity-100 text-warm-100 text-xs leading-body gap-x-2`}
    >
      <p className="[font:inherit]">
        <b>{text}</b>
      </p>
      {link?.link && link?.displayName && (
        <Anchor
          {...link}
          onClick={() =>
            promotionClicked({
              name: link.displayName,
              creative: `top_banner_${index}`,
              position: 'sitewide_banner',
              promotion_id: promotionId,
            })
          }
          className={classNames(
            '!underline transition-colors',
            appConfig.isTraeger ? 'hover:text-brand-200' : 'hover:text-neutral-600',
          )}
        />
      )}
      {countdownClock && <CountDownClock {...countdownClock} />}
    </li>
  );
};

export default SitewidePromotion;
